var map = {
	"./0-circle-fill.svg": "9dfe",
	"./0-circle.svg": "c870",
	"./0-square-fill.svg": "cd32",
	"./0-square.svg": "59cb",
	"./1-circle-fill.svg": "b91d",
	"./1-circle.svg": "fab1",
	"./1-square-fill.svg": "4e44",
	"./1-square.svg": "c9c4",
	"./123.svg": "2e676",
	"./2-circle-fill.svg": "b9b0",
	"./2-circle.svg": "359a",
	"./2-square-fill.svg": "edca",
	"./2-square.svg": "1fe0",
	"./3-circle-fill.svg": "aa6c",
	"./3-circle.svg": "2f21",
	"./3-square-fill.svg": "0832",
	"./3-square.svg": "865c",
	"./4-circle-fill.svg": "b39d",
	"./4-circle.svg": "5eeb",
	"./4-square-fill.svg": "3276",
	"./4-square.svg": "d93a",
	"./5-circle-fill.svg": "b3f4",
	"./5-circle.svg": "b131",
	"./5-square-fill.svg": "ac90",
	"./5-square.svg": "955d",
	"./6-circle-fill.svg": "a777",
	"./6-circle.svg": "395a",
	"./6-square-fill.svg": "e662",
	"./6-square.svg": "25e7",
	"./7-circle-fill.svg": "d208",
	"./7-circle.svg": "3e35",
	"./7-square-fill.svg": "a5ec",
	"./7-square.svg": "394b",
	"./8-circle-fill.svg": "67ef",
	"./8-circle.svg": "ac48",
	"./8-square-fill.svg": "e7b2",
	"./8-square.svg": "8d87",
	"./9-circle-fill.svg": "9008",
	"./9-circle.svg": "5792",
	"./9-square-fill.svg": "3d42",
	"./9-square.svg": "2ce8",
	"./activity.svg": "1fa5",
	"./airplane-engines-fill.svg": "4ca3",
	"./airplane-engines.svg": "c5d1",
	"./airplane-fill.svg": "568a",
	"./airplane.svg": "57d5",
	"./alarm-fill.svg": "a1f2",
	"./alarm.svg": "5920",
	"./alexa.svg": "da00",
	"./align-bottom.svg": "14fb",
	"./align-center.svg": "13b0",
	"./align-end.svg": "c23f",
	"./align-middle.svg": "f6ba",
	"./align-start.svg": "6577",
	"./align-top.svg": "d3a9",
	"./alipay.svg": "1231",
	"./alt.svg": "d380",
	"./amd.svg": "15d7",
	"./android.svg": "da3b",
	"./android2.svg": "9c37",
	"./app-indicator.svg": "8a91",
	"./app.svg": "133e",
	"./apple.svg": "e6de",
	"./archive-fill.svg": "137e",
	"./archive.svg": "dbb1",
	"./arrow-90deg-down.svg": "2327",
	"./arrow-90deg-left.svg": "8adc",
	"./arrow-90deg-right.svg": "66dc",
	"./arrow-90deg-up.svg": "80e7",
	"./arrow-bar-down.svg": "5503",
	"./arrow-bar-left.svg": "c698",
	"./arrow-bar-right.svg": "38d3",
	"./arrow-bar-up.svg": "11ed",
	"./arrow-clockwise.svg": "fdc9",
	"./arrow-counterclockwise.svg": "5711",
	"./arrow-down-circle-fill.svg": "de42",
	"./arrow-down-circle.svg": "189a",
	"./arrow-down-left-circle-fill.svg": "f509",
	"./arrow-down-left-circle.svg": "4a4e",
	"./arrow-down-left-square-fill.svg": "bf9f",
	"./arrow-down-left-square.svg": "6aff",
	"./arrow-down-left.svg": "e258",
	"./arrow-down-right-circle-fill.svg": "a004",
	"./arrow-down-right-circle.svg": "e838",
	"./arrow-down-right-square-fill.svg": "fe18",
	"./arrow-down-right-square.svg": "78cc",
	"./arrow-down-right.svg": "15f0",
	"./arrow-down-short.svg": "e651",
	"./arrow-down-square-fill.svg": "9f7e",
	"./arrow-down-square.svg": "7ff7",
	"./arrow-down-up.svg": "7493",
	"./arrow-down.svg": "eca6",
	"./arrow-left-circle-fill.svg": "1f8c",
	"./arrow-left-circle.svg": "af9a",
	"./arrow-left-right.svg": "4d52",
	"./arrow-left-short.svg": "50bc",
	"./arrow-left-square-fill.svg": "6ada",
	"./arrow-left-square.svg": "9c87",
	"./arrow-left.svg": "dc22",
	"./arrow-repeat.svg": "79a0",
	"./arrow-return-left.svg": "818c",
	"./arrow-return-right.svg": "8cf8",
	"./arrow-right-circle-fill.svg": "6dce",
	"./arrow-right-circle.svg": "6df1",
	"./arrow-right-short.svg": "fa30",
	"./arrow-right-square-fill.svg": "873c",
	"./arrow-right-square.svg": "e231",
	"./arrow-right.svg": "b057",
	"./arrow-through-heart-fill.svg": "17b0",
	"./arrow-through-heart.svg": "4b23",
	"./arrow-up-circle-fill.svg": "c7c6",
	"./arrow-up-circle.svg": "79c3",
	"./arrow-up-left-circle-fill.svg": "d96b",
	"./arrow-up-left-circle.svg": "a30e",
	"./arrow-up-left-square-fill.svg": "7f2a",
	"./arrow-up-left-square.svg": "d8a2",
	"./arrow-up-left.svg": "6feb",
	"./arrow-up-right-circle-fill.svg": "f7cd",
	"./arrow-up-right-circle.svg": "3daf",
	"./arrow-up-right-square-fill.svg": "b6db",
	"./arrow-up-right-square.svg": "c245",
	"./arrow-up-right.svg": "cfa7",
	"./arrow-up-short.svg": "32f5",
	"./arrow-up-square-fill.svg": "7c47",
	"./arrow-up-square.svg": "51a0",
	"./arrow-up.svg": "fe81",
	"./arrows-angle-contract.svg": "ffe5",
	"./arrows-angle-expand.svg": "75df",
	"./arrows-collapse.svg": "659e",
	"./arrows-expand.svg": "cb85",
	"./arrows-fullscreen.svg": "4cc4",
	"./arrows-move.svg": "f93f",
	"./aspect-ratio-fill.svg": "e162",
	"./aspect-ratio.svg": "de09",
	"./asterisk.svg": "2977",
	"./at.svg": "da83",
	"./award-fill.svg": "3ed3",
	"./award.svg": "4148",
	"./back.svg": "823c",
	"./backspace-fill.svg": "ca841",
	"./backspace-reverse-fill.svg": "501a",
	"./backspace-reverse.svg": "0728",
	"./backspace.svg": "22b2",
	"./badge-3d-fill.svg": "3e70",
	"./badge-3d.svg": "f3fc",
	"./badge-4k-fill.svg": "176a",
	"./badge-4k.svg": "7456",
	"./badge-8k-fill.svg": "1f6d",
	"./badge-8k.svg": "5513",
	"./badge-ad-fill.svg": "476d",
	"./badge-ad.svg": "705a",
	"./badge-ar-fill.svg": "7a6b",
	"./badge-ar.svg": "7b6d",
	"./badge-cc-fill.svg": "e287",
	"./badge-cc.svg": "9982",
	"./badge-hd-fill.svg": "2066",
	"./badge-hd.svg": "1c93",
	"./badge-sd-fill.svg": "4cab",
	"./badge-sd.svg": "e232",
	"./badge-tm-fill.svg": "6012",
	"./badge-tm.svg": "fad3",
	"./badge-vo-fill.svg": "52a6",
	"./badge-vo.svg": "e17a",
	"./badge-vr-fill.svg": "ff53",
	"./badge-vr.svg": "e3d5",
	"./badge-wc-fill.svg": "f58d",
	"./badge-wc.svg": "6925",
	"./bag-check-fill.svg": "7c95",
	"./bag-check.svg": "bc46",
	"./bag-dash-fill.svg": "1b13",
	"./bag-dash.svg": "325a",
	"./bag-fill.svg": "37d9",
	"./bag-heart-fill.svg": "6935",
	"./bag-heart.svg": "231f",
	"./bag-plus-fill.svg": "bb66",
	"./bag-plus.svg": "8e75",
	"./bag-x-fill.svg": "af20",
	"./bag-x.svg": "825b",
	"./bag.svg": "21cd",
	"./balloon-fill.svg": "9510",
	"./balloon-heart-fill.svg": "f45a",
	"./balloon-heart.svg": "4ce9",
	"./balloon.svg": "e82f",
	"./bandaid-fill.svg": "f559",
	"./bandaid.svg": "aeb9",
	"./bank.svg": "acbe",
	"./bank2.svg": "31a3",
	"./bar-chart-fill.svg": "7622",
	"./bar-chart-line-fill.svg": "a46b",
	"./bar-chart-line.svg": "3b52",
	"./bar-chart-steps.svg": "f69a",
	"./bar-chart.svg": "cf60",
	"./basket-fill.svg": "f0a9",
	"./basket.svg": "8564",
	"./basket2-fill.svg": "4b88",
	"./basket2.svg": "d284",
	"./basket3-fill.svg": "447b",
	"./basket3.svg": "4460",
	"./battery-charging.svg": "c6d0",
	"./battery-full.svg": "a9b5",
	"./battery-half.svg": "f668",
	"./battery.svg": "7546",
	"./behance.svg": "e2c7",
	"./bell-fill.svg": "6463",
	"./bell-slash-fill.svg": "2700",
	"./bell-slash.svg": "63a6",
	"./bell.svg": "1e1b",
	"./bezier.svg": "baf7",
	"./bezier2.svg": "79fc",
	"./bicycle.svg": "6acf",
	"./binoculars-fill.svg": "c649",
	"./binoculars.svg": "11c0",
	"./blockquote-left.svg": "2c69",
	"./blockquote-right.svg": "0ac7",
	"./bluetooth.svg": "b5ba",
	"./body-text.svg": "c2e9",
	"./book-fill.svg": "b5d1",
	"./book-half.svg": "0fb9",
	"./book.svg": "b067",
	"./bookmark-check-fill.svg": "ad22",
	"./bookmark-check.svg": "f25c",
	"./bookmark-dash-fill.svg": "a1eb",
	"./bookmark-dash.svg": "0caf",
	"./bookmark-fill.svg": "59a2",
	"./bookmark-heart-fill.svg": "1184",
	"./bookmark-heart.svg": "90ff",
	"./bookmark-plus-fill.svg": "4834",
	"./bookmark-plus.svg": "3ede",
	"./bookmark-star-fill.svg": "9c82",
	"./bookmark-star.svg": "c584e",
	"./bookmark-x-fill.svg": "bb31",
	"./bookmark-x.svg": "6cae",
	"./bookmark.svg": "f44a",
	"./bookmarks-fill.svg": "9bbc",
	"./bookmarks.svg": "adff",
	"./bookshelf.svg": "b61d",
	"./boombox-fill.svg": "ae55",
	"./boombox.svg": "0e46",
	"./bootstrap-fill.svg": "0fe3",
	"./bootstrap-reboot.svg": "f444",
	"./bootstrap.svg": "b411",
	"./border-all.svg": "c784",
	"./border-bottom.svg": "aa77",
	"./border-center.svg": "06f2",
	"./border-inner.svg": "3e56",
	"./border-left.svg": "5659",
	"./border-middle.svg": "386d",
	"./border-outer.svg": "4a30",
	"./border-right.svg": "e3cc",
	"./border-style.svg": "04ae",
	"./border-top.svg": "84da",
	"./border-width.svg": "d795",
	"./border.svg": "3af7",
	"./bounding-box-circles.svg": "bf9e",
	"./bounding-box.svg": "4dc6",
	"./box-arrow-down-left.svg": "7cec",
	"./box-arrow-down-right.svg": "8704",
	"./box-arrow-down.svg": "446c",
	"./box-arrow-in-down-left.svg": "3382",
	"./box-arrow-in-down-right.svg": "a882",
	"./box-arrow-in-down.svg": "a156",
	"./box-arrow-in-left.svg": "9c51",
	"./box-arrow-in-right.svg": "1bb5",
	"./box-arrow-in-up-left.svg": "e69d",
	"./box-arrow-in-up-right.svg": "6952",
	"./box-arrow-in-up.svg": "6b40",
	"./box-arrow-left.svg": "8fc3",
	"./box-arrow-right.svg": "5044",
	"./box-arrow-up-left.svg": "03af",
	"./box-arrow-up-right.svg": "cb81",
	"./box-arrow-up.svg": "9ed2",
	"./box-fill.svg": "0631",
	"./box-seam-fill.svg": "8c4b",
	"./box-seam.svg": "138c",
	"./box.svg": "8c2a",
	"./box2-fill.svg": "b914",
	"./box2-heart-fill.svg": "3aca",
	"./box2-heart.svg": "38fa",
	"./box2.svg": "2c2f",
	"./boxes.svg": "ff39",
	"./braces-asterisk.svg": "4b3c",
	"./braces.svg": "25dd",
	"./bricks.svg": "64b2",
	"./briefcase-fill.svg": "41ab",
	"./briefcase.svg": "54ef",
	"./brightness-alt-high-fill.svg": "02e0",
	"./brightness-alt-high.svg": "9985",
	"./brightness-alt-low-fill.svg": "965d",
	"./brightness-alt-low.svg": "54cf",
	"./brightness-high-fill.svg": "2b4a",
	"./brightness-high.svg": "540b",
	"./brightness-low-fill.svg": "919c",
	"./brightness-low.svg": "adf6",
	"./broadcast-pin.svg": "0616",
	"./broadcast.svg": "8ab3",
	"./browser-chrome.svg": "8a23",
	"./browser-edge.svg": "aec8",
	"./browser-firefox.svg": "f328",
	"./browser-safari.svg": "0404",
	"./brush-fill.svg": "8978",
	"./brush.svg": "e3ab",
	"./bucket-fill.svg": "dd97",
	"./bucket.svg": "041f",
	"./bug-fill.svg": "a893",
	"./bug.svg": "1ea2",
	"./building-add.svg": "a887",
	"./building-check.svg": "e37b",
	"./building-dash.svg": "55fd",
	"./building-down.svg": "7c20",
	"./building-exclamation.svg": "85dc",
	"./building-fill-add.svg": "d18c",
	"./building-fill-check.svg": "75c3",
	"./building-fill-dash.svg": "39d5",
	"./building-fill-down.svg": "6dd8",
	"./building-fill-exclamation.svg": "4e6e",
	"./building-fill-gear.svg": "5ab6",
	"./building-fill-lock.svg": "d2bbb",
	"./building-fill-slash.svg": "263d",
	"./building-fill-up.svg": "c350",
	"./building-fill-x.svg": "cce7",
	"./building-fill.svg": "2d16",
	"./building-gear.svg": "295b",
	"./building-lock.svg": "0437",
	"./building-slash.svg": "66ec",
	"./building-up.svg": "74ea",
	"./building-x.svg": "c8e1",
	"./building.svg": "87d4",
	"./buildings-fill.svg": "9d44",
	"./buildings.svg": "7642",
	"./bullseye.svg": "bb44",
	"./bus-front-fill.svg": "f3a6",
	"./bus-front.svg": "1584",
	"./c-circle-fill.svg": "2487",
	"./c-circle.svg": "fe60",
	"./c-square-fill.svg": "8a46",
	"./c-square.svg": "c0fc",
	"./calculator-fill.svg": "742f",
	"./calculator.svg": "3889",
	"./calendar-check-fill.svg": "7140",
	"./calendar-check.svg": "6b5d",
	"./calendar-date-fill.svg": "1ed5",
	"./calendar-date.svg": "5cbc",
	"./calendar-day-fill.svg": "4f5d",
	"./calendar-day.svg": "69dc",
	"./calendar-event-fill.svg": "bad7",
	"./calendar-event.svg": "9154",
	"./calendar-fill.svg": "d078",
	"./calendar-heart-fill.svg": "0a93",
	"./calendar-heart.svg": "3350",
	"./calendar-minus-fill.svg": "087f",
	"./calendar-minus.svg": "a767",
	"./calendar-month-fill.svg": "0e79",
	"./calendar-month.svg": "07be",
	"./calendar-plus-fill.svg": "04373",
	"./calendar-plus.svg": "89e6",
	"./calendar-range-fill.svg": "9db1",
	"./calendar-range.svg": "152e",
	"./calendar-week-fill.svg": "400e",
	"./calendar-week.svg": "964e",
	"./calendar-x-fill.svg": "fde5",
	"./calendar-x.svg": "0083",
	"./calendar.svg": "306e",
	"./calendar2-check-fill.svg": "5996",
	"./calendar2-check.svg": "0870",
	"./calendar2-date-fill.svg": "af21",
	"./calendar2-date.svg": "f6fd",
	"./calendar2-day-fill.svg": "ee3c",
	"./calendar2-day.svg": "c4b7",
	"./calendar2-event-fill.svg": "df77",
	"./calendar2-event.svg": "fb6f",
	"./calendar2-fill.svg": "d3e4",
	"./calendar2-heart-fill.svg": "695d",
	"./calendar2-heart.svg": "dcb4",
	"./calendar2-minus-fill.svg": "7586",
	"./calendar2-minus.svg": "1b70",
	"./calendar2-month-fill.svg": "1e1e",
	"./calendar2-month.svg": "479d",
	"./calendar2-plus-fill.svg": "34e2",
	"./calendar2-plus.svg": "3d15",
	"./calendar2-range-fill.svg": "7263",
	"./calendar2-range.svg": "8091",
	"./calendar2-week-fill.svg": "e115",
	"./calendar2-week.svg": "31dd",
	"./calendar2-x-fill.svg": "d681",
	"./calendar2-x.svg": "b5ad",
	"./calendar2.svg": "6387",
	"./calendar3-event-fill.svg": "54ba",
	"./calendar3-event.svg": "6d25",
	"./calendar3-fill.svg": "ef65",
	"./calendar3-range-fill.svg": "e2ad",
	"./calendar3-range.svg": "33a0",
	"./calendar3-week-fill.svg": "e977",
	"./calendar3-week.svg": "2903",
	"./calendar3.svg": "40028",
	"./calendar4-event.svg": "74a0",
	"./calendar4-range.svg": "2eeb",
	"./calendar4-week.svg": "3cb4",
	"./calendar4.svg": "1850",
	"./camera-fill.svg": "94c4",
	"./camera-reels-fill.svg": "2054",
	"./camera-reels.svg": "6575",
	"./camera-video-fill.svg": "abe5",
	"./camera-video-off-fill.svg": "9685",
	"./camera-video-off.svg": "a312",
	"./camera-video.svg": "7347",
	"./camera.svg": "90b3",
	"./camera2.svg": "83ca",
	"./capslock-fill.svg": "075b",
	"./capslock.svg": "0f9d",
	"./capsule-pill.svg": "4891",
	"./capsule.svg": "8b21",
	"./car-front-fill.svg": "9938",
	"./car-front.svg": "c3e8",
	"./card-checklist.svg": "9783",
	"./card-heading.svg": "af22",
	"./card-image.svg": "d7b0",
	"./card-list.svg": "3b57",
	"./card-text.svg": "d5ea",
	"./caret-down-fill.svg": "7854",
	"./caret-down-square-fill.svg": "6e63",
	"./caret-down-square.svg": "bd61",
	"./caret-down.svg": "146a",
	"./caret-left-fill.svg": "47d2",
	"./caret-left-square-fill.svg": "3ae3",
	"./caret-left-square.svg": "eafd",
	"./caret-left.svg": "7092",
	"./caret-right-fill.svg": "28b7",
	"./caret-right-square-fill.svg": "5700",
	"./caret-right-square.svg": "46b0",
	"./caret-right.svg": "5c55",
	"./caret-up-fill.svg": "5660",
	"./caret-up-square-fill.svg": "3d67",
	"./caret-up-square.svg": "7cdf",
	"./caret-up.svg": "d9b6",
	"./cart-check-fill.svg": "91e1",
	"./cart-check.svg": "754f",
	"./cart-dash-fill.svg": "9dd6",
	"./cart-dash.svg": "59b8",
	"./cart-fill.svg": "f71d",
	"./cart-plus-fill.svg": "7cab",
	"./cart-plus.svg": "7985",
	"./cart-x-fill.svg": "ce0f",
	"./cart-x.svg": "da52",
	"./cart.svg": "f144",
	"./cart2.svg": "2bc3",
	"./cart3.svg": "1add",
	"./cart4.svg": "a475",
	"./cash-coin.svg": "f8da",
	"./cash-stack.svg": "17f8",
	"./cash.svg": "cce9",
	"./cassette-fill.svg": "29f7",
	"./cassette.svg": "7243",
	"./cast.svg": "d7ff",
	"./cc-circle-fill.svg": "8c45",
	"./cc-circle.svg": "c250",
	"./cc-square-fill.svg": "d779",
	"./cc-square.svg": "f5a2",
	"./chat-dots-fill.svg": "94cb",
	"./chat-dots.svg": "76a8",
	"./chat-fill.svg": "01f5",
	"./chat-heart-fill.svg": "6762",
	"./chat-heart.svg": "6058",
	"./chat-left-dots-fill.svg": "2519",
	"./chat-left-dots.svg": "8ee5",
	"./chat-left-fill.svg": "dbf2",
	"./chat-left-heart-fill.svg": "dcb2",
	"./chat-left-heart.svg": "1b51",
	"./chat-left-quote-fill.svg": "8de1",
	"./chat-left-quote.svg": "7f90",
	"./chat-left-text-fill.svg": "5de0",
	"./chat-left-text.svg": "be91",
	"./chat-left.svg": "bdd1",
	"./chat-quote-fill.svg": "ad2e",
	"./chat-quote.svg": "1e16",
	"./chat-right-dots-fill.svg": "6182",
	"./chat-right-dots.svg": "40b6",
	"./chat-right-fill.svg": "8212",
	"./chat-right-heart-fill.svg": "89a7",
	"./chat-right-heart.svg": "13a7",
	"./chat-right-quote-fill.svg": "a0ee",
	"./chat-right-quote.svg": "1173",
	"./chat-right-text-fill.svg": "6d9b",
	"./chat-right-text.svg": "d829",
	"./chat-right.svg": "e39b",
	"./chat-square-dots-fill.svg": "a6a8",
	"./chat-square-dots.svg": "c119",
	"./chat-square-fill.svg": "af00",
	"./chat-square-heart-fill.svg": "7262",
	"./chat-square-heart.svg": "de9d",
	"./chat-square-quote-fill.svg": "b05c",
	"./chat-square-quote.svg": "ea8c",
	"./chat-square-text-fill.svg": "d661",
	"./chat-square-text.svg": "d563",
	"./chat-square.svg": "26a2",
	"./chat-text-fill.svg": "cd26",
	"./chat-text.svg": "78a3",
	"./chat.svg": "4110",
	"./check-all.svg": "86eb",
	"./check-circle-fill.svg": "b8c6",
	"./check-circle.svg": "f7e8",
	"./check-lg.svg": "ea1d",
	"./check-square-fill.svg": "23b0",
	"./check-square.svg": "dca3",
	"./check.svg": "4e19",
	"./check2-all.svg": "4172",
	"./check2-circle.svg": "e25b",
	"./check2-square.svg": "cb9c",
	"./check2.svg": "6d0a",
	"./chevron-bar-contract.svg": "1726",
	"./chevron-bar-down.svg": "3cd6",
	"./chevron-bar-expand.svg": "beb5",
	"./chevron-bar-left.svg": "fdac",
	"./chevron-bar-right.svg": "7d60",
	"./chevron-bar-up.svg": "9dd6a",
	"./chevron-compact-down.svg": "762e",
	"./chevron-compact-left.svg": "97ff",
	"./chevron-compact-right.svg": "cbdb",
	"./chevron-compact-up.svg": "d825",
	"./chevron-contract.svg": "2146",
	"./chevron-double-down.svg": "77f7",
	"./chevron-double-left.svg": "d7cb",
	"./chevron-double-right.svg": "0e0e",
	"./chevron-double-up.svg": "bb76",
	"./chevron-down.svg": "743c",
	"./chevron-expand.svg": "36f8",
	"./chevron-left.svg": "7455",
	"./chevron-right.svg": "8422",
	"./chevron-up.svg": "0bfe",
	"./circle-fill.svg": "93a3",
	"./circle-half.svg": "0f3e",
	"./circle-square.svg": "7137",
	"./circle.svg": "b8b2",
	"./clipboard-check-fill.svg": "0dec",
	"./clipboard-check.svg": "65bd",
	"./clipboard-data-fill.svg": "35c3",
	"./clipboard-data.svg": "8206",
	"./clipboard-fill.svg": "cc13",
	"./clipboard-heart-fill.svg": "93be",
	"./clipboard-heart.svg": "27af",
	"./clipboard-minus-fill.svg": "0e54",
	"./clipboard-minus.svg": "d0ab",
	"./clipboard-plus-fill.svg": "31d8",
	"./clipboard-plus.svg": "6f24",
	"./clipboard-pulse.svg": "e1ff",
	"./clipboard-x-fill.svg": "1792",
	"./clipboard-x.svg": "4bde",
	"./clipboard.svg": "b2ca",
	"./clipboard2-check-fill.svg": "7421",
	"./clipboard2-check.svg": "ed37",
	"./clipboard2-data-fill.svg": "8ba2",
	"./clipboard2-data.svg": "f792",
	"./clipboard2-fill.svg": "0195",
	"./clipboard2-heart-fill.svg": "5080",
	"./clipboard2-heart.svg": "3181",
	"./clipboard2-minus-fill.svg": "7fd2",
	"./clipboard2-minus.svg": "705e",
	"./clipboard2-plus-fill.svg": "9cc7",
	"./clipboard2-plus.svg": "3cc6",
	"./clipboard2-pulse-fill.svg": "5e35",
	"./clipboard2-pulse.svg": "1ce1",
	"./clipboard2-x-fill.svg": "226d",
	"./clipboard2-x.svg": "8645",
	"./clipboard2.svg": "c402",
	"./clock-fill.svg": "72bc",
	"./clock-history.svg": "0aa6",
	"./clock.svg": "aca2",
	"./cloud-arrow-down-fill.svg": "3e39",
	"./cloud-arrow-down.svg": "e700",
	"./cloud-arrow-up-fill.svg": "0429",
	"./cloud-arrow-up.svg": "f337",
	"./cloud-check-fill.svg": "a1ca",
	"./cloud-check.svg": "c8d6",
	"./cloud-download-fill.svg": "a7b4",
	"./cloud-download.svg": "3963",
	"./cloud-drizzle-fill.svg": "d8d5",
	"./cloud-drizzle.svg": "7fc9",
	"./cloud-fill.svg": "0f79",
	"./cloud-fog-fill.svg": "96e5",
	"./cloud-fog.svg": "b59e",
	"./cloud-fog2-fill.svg": "9902",
	"./cloud-fog2.svg": "5ba4",
	"./cloud-hail-fill.svg": "fea6",
	"./cloud-hail.svg": "cee5",
	"./cloud-haze-fill.svg": "3798",
	"./cloud-haze.svg": "0e49",
	"./cloud-haze2-fill.svg": "e0b7",
	"./cloud-haze2.svg": "1413",
	"./cloud-lightning-fill.svg": "c984",
	"./cloud-lightning-rain-fill.svg": "5735",
	"./cloud-lightning-rain.svg": "edc8",
	"./cloud-lightning.svg": "1861",
	"./cloud-minus-fill.svg": "4824",
	"./cloud-minus.svg": "b3c9",
	"./cloud-moon-fill.svg": "891f",
	"./cloud-moon.svg": "ae938",
	"./cloud-plus-fill.svg": "ab49",
	"./cloud-plus.svg": "acfd",
	"./cloud-rain-fill.svg": "19f3",
	"./cloud-rain-heavy-fill.svg": "a8f9",
	"./cloud-rain-heavy.svg": "8f9e",
	"./cloud-rain.svg": "aaa6",
	"./cloud-slash-fill.svg": "9eba",
	"./cloud-slash.svg": "c53e",
	"./cloud-sleet-fill.svg": "55b6",
	"./cloud-sleet.svg": "c0d6",
	"./cloud-snow-fill.svg": "6a76",
	"./cloud-snow.svg": "38d9",
	"./cloud-sun-fill.svg": "7e38",
	"./cloud-sun.svg": "20d8",
	"./cloud-upload-fill.svg": "1de1",
	"./cloud-upload.svg": "6791",
	"./cloud.svg": "a65c",
	"./clouds-fill.svg": "0721",
	"./clouds.svg": "2a80",
	"./cloudy-fill.svg": "108f",
	"./cloudy.svg": "f667",
	"./code-slash.svg": "7ca6",
	"./code-square.svg": "dcd4",
	"./code.svg": "b168",
	"./coin.svg": "a86c",
	"./collection-fill.svg": "8785",
	"./collection-play-fill.svg": "1b04",
	"./collection-play.svg": "0310",
	"./collection.svg": "1f88",
	"./columns-gap.svg": "e18e",
	"./columns.svg": "bf23",
	"./command.svg": "3f59",
	"./compass-fill.svg": "a3f4",
	"./compass.svg": "dc01",
	"./cone-striped.svg": "1369",
	"./cone.svg": "cfb5",
	"./controller.svg": "cec4",
	"./cpu-fill.svg": "cd69",
	"./cpu.svg": "bc60",
	"./credit-card-2-back-fill.svg": "0744",
	"./credit-card-2-back.svg": "6859",
	"./credit-card-2-front-fill.svg": "d358",
	"./credit-card-2-front.svg": "ee8d",
	"./credit-card-fill.svg": "384d",
	"./credit-card.svg": "2884",
	"./crop.svg": "c3de",
	"./cup-fill.svg": "5bf8",
	"./cup-hot-fill.svg": "8628",
	"./cup-hot.svg": "f68b",
	"./cup-straw.svg": "de2d",
	"./cup.svg": "3cd5",
	"./currency-bitcoin.svg": "4d50",
	"./currency-dollar.svg": "0d32",
	"./currency-euro.svg": "7a7a",
	"./currency-exchange.svg": "a84c",
	"./currency-pound.svg": "42a8",
	"./currency-rupee.svg": "83b3",
	"./currency-yen.svg": "4ba4",
	"./cursor-fill.svg": "c6a3",
	"./cursor-text.svg": "72fc",
	"./cursor.svg": "c39a",
	"./dash-circle-dotted.svg": "3873",
	"./dash-circle-fill.svg": "b942",
	"./dash-circle.svg": "7ede",
	"./dash-lg.svg": "f8ba",
	"./dash-square-dotted.svg": "57a9",
	"./dash-square-fill.svg": "658e",
	"./dash-square.svg": "be7f",
	"./dash.svg": "5b26",
	"./database-add.svg": "ef48",
	"./database-check.svg": "466de",
	"./database-dash.svg": "4a06",
	"./database-down.svg": "cd9a",
	"./database-exclamation.svg": "9067",
	"./database-fill-add.svg": "ccd1",
	"./database-fill-check.svg": "3b20",
	"./database-fill-dash.svg": "1ef8",
	"./database-fill-down.svg": "adb5",
	"./database-fill-exclamation.svg": "753e",
	"./database-fill-gear.svg": "5719",
	"./database-fill-lock.svg": "a381",
	"./database-fill-slash.svg": "8657",
	"./database-fill-up.svg": "6cf8",
	"./database-fill-x.svg": "324b",
	"./database-fill.svg": "7fce",
	"./database-gear.svg": "0d91",
	"./database-lock.svg": "c50e",
	"./database-slash.svg": "300b",
	"./database-up.svg": "c281",
	"./database-x.svg": "ec01",
	"./database.svg": "be80",
	"./device-hdd-fill.svg": "c59c",
	"./device-hdd.svg": "1908",
	"./device-ssd-fill.svg": "313dc",
	"./device-ssd.svg": "416d",
	"./diagram-2-fill.svg": "211f",
	"./diagram-2.svg": "aacf",
	"./diagram-3-fill.svg": "d671",
	"./diagram-3.svg": "7fa2",
	"./diamond-fill.svg": "d334",
	"./diamond-half.svg": "dc49",
	"./diamond.svg": "3915",
	"./dice-1-fill.svg": "7053",
	"./dice-1.svg": "e913",
	"./dice-2-fill.svg": "f14d",
	"./dice-2.svg": "c45b",
	"./dice-3-fill.svg": "c294",
	"./dice-3.svg": "97ae",
	"./dice-4-fill.svg": "bb99",
	"./dice-4.svg": "b4b6",
	"./dice-5-fill.svg": "e4f2",
	"./dice-5.svg": "2c7a",
	"./dice-6-fill.svg": "daaa",
	"./dice-6.svg": "71e1",
	"./disc-fill.svg": "7f2a6",
	"./disc.svg": "8c2d",
	"./discord.svg": "6990",
	"./display-fill.svg": "8be2",
	"./display.svg": "77db",
	"./displayport-fill.svg": "e0e7",
	"./displayport.svg": "d0ff",
	"./distribute-horizontal.svg": "e7be",
	"./distribute-vertical.svg": "e427",
	"./door-closed-fill.svg": "8554",
	"./door-closed.svg": "46b6",
	"./door-open-fill.svg": "2523",
	"./door-open.svg": "a34f",
	"./dot.svg": "1427",
	"./download.svg": "587a",
	"./dpad-fill.svg": "e9131",
	"./dpad.svg": "3847",
	"./dribbble.svg": "f386",
	"./dropbox.svg": "72c9",
	"./droplet-fill.svg": "edbb",
	"./droplet-half.svg": "bfb1",
	"./droplet.svg": "4546",
	"./ear-fill.svg": "3c96",
	"./ear.svg": "b364",
	"./earbuds.svg": "f644",
	"./easel-fill.svg": "d7c8",
	"./easel.svg": "6cc5",
	"./easel2-fill.svg": "4f5f",
	"./easel2.svg": "5f29",
	"./easel3-fill.svg": "a7b8",
	"./easel3.svg": "b1bd",
	"./egg-fill.svg": "91b8",
	"./egg-fried.svg": "ba37",
	"./egg.svg": "2984",
	"./eject-fill.svg": "e30f",
	"./eject.svg": "d7d5",
	"./emoji-angry-fill.svg": "421d",
	"./emoji-angry.svg": "ed7c",
	"./emoji-dizzy-fill.svg": "d3dc",
	"./emoji-dizzy.svg": "6d55",
	"./emoji-expressionless-fill.svg": "f1aa",
	"./emoji-expressionless.svg": "aee5",
	"./emoji-frown-fill.svg": "a324",
	"./emoji-frown.svg": "e1da",
	"./emoji-heart-eyes-fill.svg": "6d20",
	"./emoji-heart-eyes.svg": "dd18",
	"./emoji-kiss-fill.svg": "d896",
	"./emoji-kiss.svg": "66497",
	"./emoji-laughing-fill.svg": "6f8d",
	"./emoji-laughing.svg": "84cd",
	"./emoji-neutral-fill.svg": "96c9",
	"./emoji-neutral.svg": "a8c5",
	"./emoji-smile-fill.svg": "7321",
	"./emoji-smile-upside-down-fill.svg": "766d",
	"./emoji-smile-upside-down.svg": "c202",
	"./emoji-smile.svg": "3127",
	"./emoji-sunglasses-fill.svg": "8d17",
	"./emoji-sunglasses.svg": "9f3a",
	"./emoji-wink-fill.svg": "ec60",
	"./emoji-wink.svg": "76ca",
	"./envelope-at-fill.svg": "b0f5",
	"./envelope-at.svg": "1841",
	"./envelope-check-fill.svg": "cba4",
	"./envelope-check.svg": "be41",
	"./envelope-dash-fill.svg": "dd72",
	"./envelope-dash.svg": "fbae",
	"./envelope-exclamation-fill.svg": "5f39",
	"./envelope-exclamation.svg": "b2f1",
	"./envelope-fill.svg": "09f3",
	"./envelope-heart-fill.svg": "f92f",
	"./envelope-heart.svg": "2571",
	"./envelope-open-fill.svg": "7a66",
	"./envelope-open-heart-fill.svg": "123a",
	"./envelope-open-heart.svg": "3edb",
	"./envelope-open.svg": "8f29",
	"./envelope-paper-fill.svg": "c9ee",
	"./envelope-paper-heart-fill.svg": "5715",
	"./envelope-paper-heart.svg": "2a3f",
	"./envelope-paper.svg": "7737",
	"./envelope-plus-fill.svg": "6437",
	"./envelope-plus.svg": "d218",
	"./envelope-slash-fill.svg": "1911",
	"./envelope-slash.svg": "8557",
	"./envelope-x-fill.svg": "b9ac",
	"./envelope-x.svg": "b40a",
	"./envelope.svg": "e948",
	"./eraser-fill.svg": "121e",
	"./eraser.svg": "c5c3",
	"./escape.svg": "e794",
	"./ethernet.svg": "a2e8",
	"./ev-front-fill.svg": "5c2a",
	"./ev-front.svg": "805b",
	"./ev-station-fill.svg": "d860",
	"./ev-station.svg": "944d",
	"./exclamation-circle-fill.svg": "1c85",
	"./exclamation-circle.svg": "d137",
	"./exclamation-diamond-fill.svg": "c850",
	"./exclamation-diamond.svg": "cec0",
	"./exclamation-lg.svg": "b5c0",
	"./exclamation-octagon-fill.svg": "73de",
	"./exclamation-octagon.svg": "c7b4",
	"./exclamation-square-fill.svg": "70ac",
	"./exclamation-square.svg": "28e3",
	"./exclamation-triangle-fill.svg": "6703",
	"./exclamation-triangle.svg": "bbe4",
	"./exclamation.svg": "015f",
	"./exclude.svg": "98b2",
	"./explicit-fill.svg": "149e",
	"./explicit.svg": "910e",
	"./eye-fill.svg": "3e09",
	"./eye-slash-fill.svg": "6cab",
	"./eye-slash.svg": "dc7c",
	"./eye.svg": "7d06",
	"./eyedropper.svg": "57df",
	"./eyeglasses.svg": "6756",
	"./facebook.svg": "4332",
	"./fan.svg": "5c50",
	"./fast-forward-btn-fill.svg": "edf0",
	"./fast-forward-btn.svg": "c5c4",
	"./fast-forward-circle-fill.svg": "6abb",
	"./fast-forward-circle.svg": "333b",
	"./fast-forward-fill.svg": "93eb",
	"./fast-forward.svg": "c29a",
	"./file-arrow-down-fill.svg": "1f7c",
	"./file-arrow-down.svg": "61db",
	"./file-arrow-up-fill.svg": "b686",
	"./file-arrow-up.svg": "b795",
	"./file-bar-graph-fill.svg": "0e9c",
	"./file-bar-graph.svg": "ff1d",
	"./file-binary-fill.svg": "2983",
	"./file-binary.svg": "fc99",
	"./file-break-fill.svg": "1ef4",
	"./file-break.svg": "68c9",
	"./file-check-fill.svg": "655b",
	"./file-check.svg": "8cff",
	"./file-code-fill.svg": "3a02",
	"./file-code.svg": "8aae",
	"./file-diff-fill.svg": "57c3",
	"./file-diff.svg": "81d52",
	"./file-earmark-arrow-down-fill.svg": "36ec",
	"./file-earmark-arrow-down.svg": "bfd1",
	"./file-earmark-arrow-up-fill.svg": "13a8",
	"./file-earmark-arrow-up.svg": "bd71",
	"./file-earmark-bar-graph-fill.svg": "f6ca",
	"./file-earmark-bar-graph.svg": "15a5",
	"./file-earmark-binary-fill.svg": "fe37",
	"./file-earmark-binary.svg": "c94a",
	"./file-earmark-break-fill.svg": "669b",
	"./file-earmark-break.svg": "eef9",
	"./file-earmark-check-fill.svg": "a69c",
	"./file-earmark-check.svg": "6d38",
	"./file-earmark-code-fill.svg": "e5ea",
	"./file-earmark-code.svg": "167a",
	"./file-earmark-diff-fill.svg": "5903",
	"./file-earmark-diff.svg": "5ce5",
	"./file-earmark-easel-fill.svg": "0762",
	"./file-earmark-easel.svg": "f889",
	"./file-earmark-excel-fill.svg": "dbaf",
	"./file-earmark-excel.svg": "6efe",
	"./file-earmark-fill.svg": "b1ff",
	"./file-earmark-font-fill.svg": "cf4f",
	"./file-earmark-font.svg": "f20e",
	"./file-earmark-image-fill.svg": "d7c5",
	"./file-earmark-image.svg": "f7fa",
	"./file-earmark-lock-fill.svg": "f7c7",
	"./file-earmark-lock.svg": "2b8b",
	"./file-earmark-lock2-fill.svg": "094c",
	"./file-earmark-lock2.svg": "3700",
	"./file-earmark-medical-fill.svg": "9db4",
	"./file-earmark-medical.svg": "f2f5",
	"./file-earmark-minus-fill.svg": "44fd",
	"./file-earmark-minus.svg": "573a",
	"./file-earmark-music-fill.svg": "47cb",
	"./file-earmark-music.svg": "7c42",
	"./file-earmark-pdf-fill.svg": "d8ac",
	"./file-earmark-pdf.svg": "9e98",
	"./file-earmark-person-fill.svg": "1b46",
	"./file-earmark-person.svg": "3c27",
	"./file-earmark-play-fill.svg": "c4e5",
	"./file-earmark-play.svg": "c9f1",
	"./file-earmark-plus-fill.svg": "3b7b",
	"./file-earmark-plus.svg": "8b97",
	"./file-earmark-post-fill.svg": "83e5",
	"./file-earmark-post.svg": "249c",
	"./file-earmark-ppt-fill.svg": "daa0",
	"./file-earmark-ppt.svg": "4c9d",
	"./file-earmark-richtext-fill.svg": "53c7",
	"./file-earmark-richtext.svg": "6b37",
	"./file-earmark-ruled-fill.svg": "d75b",
	"./file-earmark-ruled.svg": "205a",
	"./file-earmark-slides-fill.svg": "bfbd",
	"./file-earmark-slides.svg": "6b61",
	"./file-earmark-spreadsheet-fill.svg": "afc2",
	"./file-earmark-spreadsheet.svg": "2ad8",
	"./file-earmark-text-fill.svg": "c772",
	"./file-earmark-text.svg": "1cb6",
	"./file-earmark-word-fill.svg": "233d",
	"./file-earmark-word.svg": "43eb",
	"./file-earmark-x-fill.svg": "1392",
	"./file-earmark-x.svg": "a703",
	"./file-earmark-zip-fill.svg": "f83e",
	"./file-earmark-zip.svg": "1638",
	"./file-earmark.svg": "ca1a",
	"./file-easel-fill.svg": "8709",
	"./file-easel.svg": "79dd",
	"./file-excel-fill.svg": "59a1",
	"./file-excel.svg": "0b0e",
	"./file-fill.svg": "f6ef",
	"./file-font-fill.svg": "874e",
	"./file-font.svg": "80be",
	"./file-image-fill.svg": "d817",
	"./file-image.svg": "e500",
	"./file-lock-fill.svg": "e6d2",
	"./file-lock.svg": "bee8",
	"./file-lock2-fill.svg": "e01b",
	"./file-lock2.svg": "91a9",
	"./file-medical-fill.svg": "a319",
	"./file-medical.svg": "17c1",
	"./file-minus-fill.svg": "9e87",
	"./file-minus.svg": "7001",
	"./file-music-fill.svg": "76423",
	"./file-music.svg": "3190",
	"./file-pdf-fill.svg": "e3b6",
	"./file-pdf.svg": "ec0e",
	"./file-person-fill.svg": "dd48",
	"./file-person.svg": "27fe",
	"./file-play-fill.svg": "5188",
	"./file-play.svg": "c4c3",
	"./file-plus-fill.svg": "7572",
	"./file-plus.svg": "d3f1",
	"./file-post-fill.svg": "c7c9",
	"./file-post.svg": "3b45",
	"./file-ppt-fill.svg": "7c3e",
	"./file-ppt.svg": "8fb9",
	"./file-richtext-fill.svg": "3d2b",
	"./file-richtext.svg": "1bfb",
	"./file-ruled-fill.svg": "8fc1",
	"./file-ruled.svg": "78d7",
	"./file-slides-fill.svg": "ee0c",
	"./file-slides.svg": "22f0",
	"./file-spreadsheet-fill.svg": "efdf",
	"./file-spreadsheet.svg": "88bb",
	"./file-text-fill.svg": "17d7",
	"./file-text.svg": "2d20",
	"./file-word-fill.svg": "117c",
	"./file-word.svg": "5d5a",
	"./file-x-fill.svg": "63e7",
	"./file-x.svg": "7b33",
	"./file-zip-fill.svg": "4783",
	"./file-zip.svg": "f86a",
	"./file.svg": "5f9f",
	"./files-alt.svg": "1a5a",
	"./files.svg": "eac51",
	"./filetype-aac.svg": "dc72",
	"./filetype-ai.svg": "39c9",
	"./filetype-bmp.svg": "d8d1",
	"./filetype-cs.svg": "b061",
	"./filetype-css.svg": "9c48",
	"./filetype-csv.svg": "c34a",
	"./filetype-doc.svg": "6051",
	"./filetype-docx.svg": "4746",
	"./filetype-exe.svg": "f580",
	"./filetype-gif.svg": "4593",
	"./filetype-heic.svg": "f5cc",
	"./filetype-html.svg": "6825",
	"./filetype-java.svg": "dbe3",
	"./filetype-jpg.svg": "f1c3",
	"./filetype-js.svg": "8361",
	"./filetype-json.svg": "d181",
	"./filetype-jsx.svg": "d306",
	"./filetype-key.svg": "ca9c",
	"./filetype-m4p.svg": "ae5a",
	"./filetype-md.svg": "1c4b",
	"./filetype-mdx.svg": "990b",
	"./filetype-mov.svg": "4ee5",
	"./filetype-mp3.svg": "2f1f",
	"./filetype-mp4.svg": "7728",
	"./filetype-otf.svg": "e55c",
	"./filetype-pdf.svg": "49c8",
	"./filetype-php.svg": "e435",
	"./filetype-png.svg": "187f",
	"./filetype-ppt.svg": "9d91",
	"./filetype-pptx.svg": "dce8",
	"./filetype-psd.svg": "9c76",
	"./filetype-py.svg": "51bc",
	"./filetype-raw.svg": "0f74",
	"./filetype-rb.svg": "2432",
	"./filetype-sass.svg": "6e7a",
	"./filetype-scss.svg": "976f",
	"./filetype-sh.svg": "7a9f",
	"./filetype-sql.svg": "09d1",
	"./filetype-svg.svg": "e074",
	"./filetype-tiff.svg": "1ecc",
	"./filetype-tsx.svg": "c00c",
	"./filetype-ttf.svg": "f271",
	"./filetype-txt.svg": "6b1a",
	"./filetype-wav.svg": "c327",
	"./filetype-woff.svg": "d056",
	"./filetype-xls.svg": "8b42",
	"./filetype-xlsx.svg": "993d",
	"./filetype-xml.svg": "a819",
	"./filetype-yml.svg": "6ddf0",
	"./film.svg": "7056",
	"./filter-circle-fill.svg": "cb2a",
	"./filter-circle.svg": "beff",
	"./filter-left.svg": "0bf4",
	"./filter-right.svg": "3473",
	"./filter-square-fill.svg": "5acf",
	"./filter-square.svg": "5cc4",
	"./filter.svg": "de4e",
	"./fingerprint.svg": "3172",
	"./fire.svg": "b920",
	"./flag-fill.svg": "b924",
	"./flag.svg": "c342",
	"./flower1.svg": "6f95",
	"./flower2.svg": "d6d3",
	"./flower3.svg": "e98e",
	"./folder-check.svg": "389c",
	"./folder-fill.svg": "4552",
	"./folder-minus.svg": "7570",
	"./folder-plus.svg": "e799",
	"./folder-symlink-fill.svg": "1a44",
	"./folder-symlink.svg": "062d",
	"./folder-x.svg": "184f",
	"./folder.svg": "9a72",
	"./folder2-open.svg": "0c48",
	"./folder2.svg": "f1836",
	"./fonts.svg": "a40e",
	"./forward-fill.svg": "e44c",
	"./forward.svg": "8b0c",
	"./front.svg": "51f8",
	"./fuel-pump-diesel-fill.svg": "65f09",
	"./fuel-pump-diesel.svg": "24be",
	"./fuel-pump-fill.svg": "5bb0",
	"./fuel-pump.svg": "2853",
	"./fullscreen-exit.svg": "0a0f",
	"./fullscreen.svg": "ee80",
	"./funnel-fill.svg": "9c67",
	"./funnel.svg": "b21c",
	"./gear-fill.svg": "e5b7",
	"./gear-wide-connected.svg": "a21d",
	"./gear-wide.svg": "63ba",
	"./gear.svg": "44e2",
	"./gem.svg": "e559",
	"./gender-ambiguous.svg": "4310",
	"./gender-female.svg": "d05b",
	"./gender-male.svg": "9849",
	"./gender-trans.svg": "8912",
	"./geo-alt-fill.svg": "e436",
	"./geo-alt.svg": "9812",
	"./geo-fill.svg": "eefb",
	"./geo.svg": "55c5",
	"./gift-fill.svg": "6ee6",
	"./gift.svg": "b4db",
	"./git.svg": "a339",
	"./github.svg": "91fc",
	"./globe-americas.svg": "7a59",
	"./globe-asia-australia.svg": "599d",
	"./globe-central-south-asia.svg": "4a9a",
	"./globe-europe-africa.svg": "d7bf",
	"./globe.svg": "2f34",
	"./globe2.svg": "9d84",
	"./google-play.svg": "4e72",
	"./google.svg": "6073",
	"./gpu-card.svg": "e573",
	"./graph-down-arrow.svg": "23b6",
	"./graph-down.svg": "a111",
	"./graph-up-arrow.svg": "66ae",
	"./graph-up.svg": "b16d",
	"./grid-1x2-fill.svg": "9678",
	"./grid-1x2.svg": "ee9c",
	"./grid-3x2-gap-fill.svg": "fe47",
	"./grid-3x2-gap.svg": "1e26",
	"./grid-3x2.svg": "8f9c",
	"./grid-3x3-gap-fill.svg": "a0fb",
	"./grid-3x3-gap.svg": "d148",
	"./grid-3x3.svg": "6376",
	"./grid-fill.svg": "e6c5",
	"./grid.svg": "c9d7",
	"./grip-horizontal.svg": "c48a",
	"./grip-vertical.svg": "53fd",
	"./h-circle-fill.svg": "9391",
	"./h-circle.svg": "5385",
	"./h-square-fill.svg": "fe67",
	"./h-square.svg": "0ff2",
	"./hammer.svg": "c828",
	"./hand-index-fill.svg": "4e6c",
	"./hand-index-thumb-fill.svg": "c00d",
	"./hand-index-thumb.svg": "e14f",
	"./hand-index.svg": "1472",
	"./hand-thumbs-down-fill.svg": "cab4",
	"./hand-thumbs-down.svg": "567f",
	"./hand-thumbs-up-fill.svg": "3d81",
	"./hand-thumbs-up.svg": "473f",
	"./handbag-fill.svg": "8ca7",
	"./handbag.svg": "77fd",
	"./hash.svg": "7efe",
	"./hdd-fill.svg": "7e34",
	"./hdd-network-fill.svg": "02c6",
	"./hdd-network.svg": "7150",
	"./hdd-rack-fill.svg": "b2ed",
	"./hdd-rack.svg": "0326",
	"./hdd-stack-fill.svg": "c260",
	"./hdd-stack.svg": "5001",
	"./hdd.svg": "70f1",
	"./hdmi-fill.svg": "8aa3",
	"./hdmi.svg": "4ea6",
	"./headphones.svg": "e2e3",
	"./headset-vr.svg": "96e9",
	"./headset.svg": "fadb",
	"./heart-arrow.svg": "b8bd",
	"./heart-fill.svg": "ab5d",
	"./heart-half.svg": "15ae",
	"./heart-pulse-fill.svg": "a5d1",
	"./heart-pulse.svg": "4a36",
	"./heart.svg": "1c94",
	"./heartbreak-fill.svg": "575b",
	"./heartbreak.svg": "b1e6",
	"./hearts.svg": "191b",
	"./heptagon-fill.svg": "e43f",
	"./heptagon-half.svg": "45c3",
	"./heptagon.svg": "81f5",
	"./hexagon-fill.svg": "9e74",
	"./hexagon-half.svg": "c599",
	"./hexagon.svg": "68e7",
	"./hospital-fill.svg": "234a",
	"./hospital.svg": "af5d",
	"./hourglass-bottom.svg": "a226",
	"./hourglass-split.svg": "9dd3",
	"./hourglass-top.svg": "149c",
	"./hourglass.svg": "3d9c",
	"./house-add-fill.svg": "e551",
	"./house-add.svg": "ede5",
	"./house-check-fill.svg": "1443",
	"./house-check.svg": "23e9",
	"./house-dash-fill.svg": "32bb",
	"./house-dash.svg": "0a4a",
	"./house-door-fill.svg": "cdae",
	"./house-door.svg": "01ef",
	"./house-down-fill.svg": "c25b",
	"./house-down.svg": "20aa",
	"./house-exclamation-fill.svg": "cbc0",
	"./house-exclamation.svg": "8bf2",
	"./house-fill.svg": "b108",
	"./house-gear-fill.svg": "73ef",
	"./house-gear.svg": "6cce",
	"./house-heart-fill.svg": "14f0",
	"./house-heart.svg": "018d",
	"./house-lock-fill.svg": "f69e",
	"./house-lock.svg": "6113",
	"./house-slash-fill.svg": "0598",
	"./house-slash.svg": "50ee",
	"./house-up-fill.svg": "720e",
	"./house-up.svg": "36c0",
	"./house-x-fill.svg": "98f1",
	"./house-x.svg": "49c2",
	"./house.svg": "167ae",
	"./houses-fill.svg": "c41e",
	"./houses.svg": "067f",
	"./hr.svg": "fa4a",
	"./hurricane.svg": "d92b",
	"./hypnotize.svg": "4585",
	"./image-alt.svg": "199f",
	"./image-fill.svg": "e61a",
	"./image.svg": "b995",
	"./images.svg": "0c54",
	"./inbox-fill.svg": "2147",
	"./inbox.svg": "18f6",
	"./inboxes-fill.svg": "e0d1",
	"./inboxes.svg": "ec71",
	"./incognito.svg": "26a9",
	"./indent.svg": "d379",
	"./infinity.svg": "963a",
	"./info-circle-fill.svg": "ed1a",
	"./info-circle.svg": "adb2",
	"./info-lg.svg": "9794",
	"./info-square-fill.svg": "894c",
	"./info-square.svg": "d6d2",
	"./info.svg": "953f",
	"./input-cursor-text.svg": "cb07",
	"./input-cursor.svg": "7c9a",
	"./instagram.svg": "08fd",
	"./intersect.svg": "9c31",
	"./journal-album.svg": "ea86",
	"./journal-arrow-down.svg": "7da2",
	"./journal-arrow-up.svg": "eace",
	"./journal-bookmark-fill.svg": "b9e1",
	"./journal-bookmark.svg": "aaed",
	"./journal-check.svg": "762b",
	"./journal-code.svg": "73a5",
	"./journal-medical.svg": "389f",
	"./journal-minus.svg": "8dee",
	"./journal-plus.svg": "8146",
	"./journal-richtext.svg": "32f1",
	"./journal-text.svg": "5cd4",
	"./journal-x.svg": "70f7",
	"./journal.svg": "9d63",
	"./journals.svg": "582c",
	"./joystick.svg": "a552",
	"./justify-left.svg": "c2d4",
	"./justify-right.svg": "1568",
	"./justify.svg": "696a",
	"./kanban-fill.svg": "9265",
	"./kanban.svg": "fe93",
	"./key-fill.svg": "8f9cb",
	"./key.svg": "dd08",
	"./keyboard-fill.svg": "cd4b",
	"./keyboard.svg": "ae0b",
	"./ladder.svg": "4b32",
	"./lamp-fill.svg": "18cc",
	"./lamp.svg": "685f",
	"./laptop-fill.svg": "bc98",
	"./laptop.svg": "a952",
	"./layer-backward.svg": "9eb0",
	"./layer-forward.svg": "3aba",
	"./layers-fill.svg": "c2d3",
	"./layers-half.svg": "6eb3",
	"./layers.svg": "6444",
	"./layout-sidebar-inset-reverse.svg": "6902",
	"./layout-sidebar-inset.svg": "de49",
	"./layout-sidebar-reverse.svg": "ab5e",
	"./layout-sidebar.svg": "ea24",
	"./layout-split.svg": "c3b7",
	"./layout-text-sidebar-reverse.svg": "08d3",
	"./layout-text-sidebar.svg": "6804",
	"./layout-text-window-reverse.svg": "aa0f",
	"./layout-text-window.svg": "6e35",
	"./layout-three-columns.svg": "fc21",
	"./layout-wtf.svg": "d18d",
	"./life-preserver.svg": "fb97",
	"./lightbulb-fill.svg": "642d",
	"./lightbulb-off-fill.svg": "2fec",
	"./lightbulb-off.svg": "2486",
	"./lightbulb.svg": "8b216",
	"./lightning-charge-fill.svg": "cda1",
	"./lightning-charge.svg": "8511",
	"./lightning-fill.svg": "4c9e",
	"./lightning.svg": "a192",
	"./line.svg": "c165",
	"./link-45deg.svg": "fd75",
	"./link.svg": "6531",
	"./linkedin.svg": "35a8",
	"./list-check.svg": "4b39",
	"./list-columns-reverse.svg": "9977",
	"./list-columns.svg": "4fe9",
	"./list-nested.svg": "d4aa",
	"./list-ol.svg": "4083",
	"./list-stars.svg": "54b4",
	"./list-task.svg": "22bd",
	"./list-ul.svg": "b544",
	"./list.svg": "35d4",
	"./lock-fill.svg": "bfc9",
	"./lock.svg": "ef11",
	"./lungs-fill.svg": "7f9e",
	"./lungs.svg": "8a236",
	"./magic.svg": "0f29",
	"./magnet-fill.svg": "ad78",
	"./magnet.svg": "aeaa",
	"./mailbox.svg": "2443",
	"./mailbox2.svg": "5892",
	"./map-fill.svg": "4b35",
	"./map.svg": "abcd",
	"./markdown-fill.svg": "c63e",
	"./markdown.svg": "340c",
	"./mask.svg": "9bfb",
	"./mastodon.svg": "f559a",
	"./medium.svg": "6fb5",
	"./megaphone-fill.svg": "91ce",
	"./megaphone.svg": "1795",
	"./memory.svg": "077a",
	"./menu-app-fill.svg": "8d31",
	"./menu-app.svg": "dddf",
	"./menu-button-fill.svg": "6068",
	"./menu-button-wide-fill.svg": "6f0f",
	"./menu-button-wide.svg": "4f8a",
	"./menu-button.svg": "b70d",
	"./menu-down.svg": "07c5",
	"./menu-up.svg": "977b",
	"./messenger.svg": "d2d4",
	"./meta.svg": "4b5d",
	"./mic-fill.svg": "d3044",
	"./mic-mute-fill.svg": "ec96",
	"./mic-mute.svg": "7657",
	"./mic.svg": "2a7a",
	"./microsoft-teams.svg": "e6a5",
	"./microsoft.svg": "413e",
	"./minecart-loaded.svg": "a467",
	"./minecart.svg": "02e2",
	"./modem-fill.svg": "8f76",
	"./modem.svg": "2f70",
	"./moisture.svg": "5b6d",
	"./moon-fill.svg": "34103",
	"./moon-stars-fill.svg": "01bf",
	"./moon-stars.svg": "a3be",
	"./moon.svg": "8810",
	"./mortarboard-fill.svg": "7d9c",
	"./mortarboard.svg": "d8c9",
	"./motherboard-fill.svg": "7c80",
	"./motherboard.svg": "99e7",
	"./mouse-fill.svg": "c23a",
	"./mouse.svg": "e931",
	"./mouse2-fill.svg": "9aeb",
	"./mouse2.svg": "dc6a",
	"./mouse3-fill.svg": "a91c",
	"./mouse3.svg": "7785",
	"./music-note-beamed.svg": "36c5",
	"./music-note-list.svg": "d1e3",
	"./music-note.svg": "a6b0",
	"./music-player-fill.svg": "2a8e",
	"./music-player.svg": "85119",
	"./newspaper.svg": "dc5a",
	"./nintendo-switch.svg": "4eea",
	"./node-minus-fill.svg": "19a5",
	"./node-minus.svg": "9f86",
	"./node-plus-fill.svg": "3caa",
	"./node-plus.svg": "94fd",
	"./nut-fill.svg": "fe70",
	"./nut.svg": "d03d",
	"./nvidia.svg": "253f0",
	"./octagon-fill.svg": "92dd",
	"./octagon-half.svg": "e332",
	"./octagon.svg": "4c7a",
	"./optical-audio-fill.svg": "5190",
	"./optical-audio.svg": "ac96",
	"./option.svg": "15b1",
	"./outlet.svg": "c520",
	"./p-circle-fill.svg": "7462",
	"./p-circle.svg": "a337",
	"./p-square-fill.svg": "122d",
	"./p-square.svg": "c20d7",
	"./paint-bucket.svg": "2c7b",
	"./palette-fill.svg": "8e13",
	"./palette.svg": "726c",
	"./palette2.svg": "24d6",
	"./paperclip.svg": "3451",
	"./paragraph.svg": "a566",
	"./pass-fill.svg": "a240",
	"./pass.svg": "27ac",
	"./patch-check-fill.svg": "e4c5",
	"./patch-check.svg": "b4ef",
	"./patch-exclamation-fill.svg": "7003",
	"./patch-exclamation.svg": "f050",
	"./patch-minus-fill.svg": "386d1",
	"./patch-minus.svg": "c963",
	"./patch-plus-fill.svg": "3efd",
	"./patch-plus.svg": "02cf",
	"./patch-question-fill.svg": "6a20",
	"./patch-question.svg": "0e58",
	"./pause-btn-fill.svg": "7d85",
	"./pause-btn.svg": "2c64",
	"./pause-circle-fill.svg": "8803",
	"./pause-circle.svg": "e4ed",
	"./pause-fill.svg": "62d1",
	"./pause.svg": "f136",
	"./paypal.svg": "a2ff",
	"./pc-display-horizontal.svg": "35e6",
	"./pc-display.svg": "1616",
	"./pc-horizontal.svg": "4274",
	"./pc.svg": "317c",
	"./pci-card.svg": "c739",
	"./peace-fill.svg": "5a8b",
	"./peace.svg": "7c40",
	"./pen-fill.svg": "2d37",
	"./pen.svg": "155e",
	"./pencil-fill.svg": "951d",
	"./pencil-square.svg": "f4af",
	"./pencil.svg": "eec7",
	"./pentagon-fill.svg": "d157",
	"./pentagon-half.svg": "08a1",
	"./pentagon.svg": "b0c5",
	"./people-fill.svg": "5e94",
	"./people.svg": "8ea5",
	"./percent.svg": "1abf",
	"./person-add.svg": "e754",
	"./person-badge-fill.svg": "1f881",
	"./person-badge.svg": "8d04",
	"./person-bounding-box.svg": "539f",
	"./person-check-fill.svg": "bb29",
	"./person-check.svg": "2698",
	"./person-circle.svg": "ef8a",
	"./person-dash-fill.svg": "846a",
	"./person-dash.svg": "d8e4",
	"./person-down.svg": "3522",
	"./person-exclamation.svg": "e9b6",
	"./person-fill-add.svg": "15f0b",
	"./person-fill-check.svg": "a3ea",
	"./person-fill-dash.svg": "01c2",
	"./person-fill-down.svg": "61c8",
	"./person-fill-exclamation.svg": "2aa6",
	"./person-fill-gear.svg": "9d2e",
	"./person-fill-lock.svg": "c147",
	"./person-fill-slash.svg": "a9bb",
	"./person-fill-up.svg": "40b8",
	"./person-fill-x.svg": "69bb",
	"./person-fill.svg": "2d57",
	"./person-gear.svg": "c22e",
	"./person-heart.svg": "4e99",
	"./person-hearts.svg": "2ee1",
	"./person-lines-fill.svg": "1d1b",
	"./person-lock.svg": "9cb5",
	"./person-plus-fill.svg": "3e55",
	"./person-plus.svg": "01b5",
	"./person-rolodex.svg": "d9b1",
	"./person-slash.svg": "bbef",
	"./person-square.svg": "7230",
	"./person-up.svg": "dbc5",
	"./person-vcard-fill.svg": "c0e1",
	"./person-vcard.svg": "29e5",
	"./person-video.svg": "f559e",
	"./person-video2.svg": "13c8",
	"./person-video3.svg": "cd55",
	"./person-workspace.svg": "1cfc",
	"./person-x-fill.svg": "b34a",
	"./person-x.svg": "260d",
	"./person.svg": "3a47",
	"./phone-fill.svg": "69c3",
	"./phone-flip.svg": "1d18",
	"./phone-landscape-fill.svg": "3b82",
	"./phone-landscape.svg": "7e8f",
	"./phone-vibrate-fill.svg": "4b4b",
	"./phone-vibrate.svg": "fe20",
	"./phone.svg": "8ad4",
	"./pie-chart-fill.svg": "5a8c",
	"./pie-chart.svg": "4f09",
	"./piggy-bank-fill.svg": "d3dc4",
	"./piggy-bank.svg": "6220",
	"./pin-angle-fill.svg": "38a3",
	"./pin-angle.svg": "2b28",
	"./pin-fill.svg": "e9a7",
	"./pin-map-fill.svg": "5973",
	"./pin-map.svg": "1b1e",
	"./pin.svg": "885a",
	"./pinterest.svg": "5e1d",
	"./pip-fill.svg": "bfb6",
	"./pip.svg": "9cb7",
	"./play-btn-fill.svg": "dd7f",
	"./play-btn.svg": "7766",
	"./play-circle-fill.svg": "66e2",
	"./play-circle.svg": "a0c9",
	"./play-fill.svg": "9d40",
	"./play.svg": "8f4d",
	"./playstation.svg": "7a5e",
	"./plug-fill.svg": "e167",
	"./plug.svg": "d7ec",
	"./plugin.svg": "f301",
	"./plus-circle-dotted.svg": "2f4e",
	"./plus-circle-fill.svg": "2e65",
	"./plus-circle.svg": "f0f6",
	"./plus-lg.svg": "c40f",
	"./plus-slash-minus.svg": "6d1c",
	"./plus-square-dotted.svg": "5974",
	"./plus-square-fill.svg": "2178",
	"./plus-square.svg": "2880",
	"./plus.svg": "3256",
	"./postage-fill.svg": "e09e",
	"./postage-heart-fill.svg": "9ba1",
	"./postage-heart.svg": "41b3",
	"./postage.svg": "9615",
	"./postcard-fill.svg": "2ca7",
	"./postcard-heart-fill.svg": "a702",
	"./postcard-heart.svg": "e923",
	"./postcard.svg": "dc8e",
	"./power.svg": "1b59",
	"./prescription.svg": "5e41",
	"./prescription2.svg": "2a6e",
	"./printer-fill.svg": "a6f7",
	"./printer.svg": "2a11",
	"./projector-fill.svg": "4467",
	"./projector.svg": "1c4e",
	"./puzzle-fill.svg": "d1f6",
	"./puzzle.svg": "c941",
	"./qr-code-scan.svg": "d4fa",
	"./qr-code.svg": "8c58",
	"./question-circle-fill.svg": "7077",
	"./question-circle.svg": "a7f8",
	"./question-diamond-fill.svg": "5a28",
	"./question-diamond.svg": "3f6e",
	"./question-lg.svg": "c2d1",
	"./question-octagon-fill.svg": "6d47",
	"./question-octagon.svg": "9e0e",
	"./question-square-fill.svg": "8c61",
	"./question-square.svg": "d20b",
	"./question.svg": "a5ece",
	"./quora.svg": "1fc1",
	"./quote.svg": "34f1",
	"./r-circle-fill.svg": "461b",
	"./r-circle.svg": "f954",
	"./r-square-fill.svg": "7c03",
	"./r-square.svg": "4739",
	"./radioactive.svg": "448b",
	"./rainbow.svg": "f0e9",
	"./receipt-cutoff.svg": "5268",
	"./receipt.svg": "c54f",
	"./reception-0.svg": "1197",
	"./reception-1.svg": "6f62",
	"./reception-2.svg": "c85b",
	"./reception-3.svg": "a4e7",
	"./reception-4.svg": "34bd",
	"./record-btn-fill.svg": "694a",
	"./record-btn.svg": "329f",
	"./record-circle-fill.svg": "0dc0",
	"./record-circle.svg": "3795",
	"./record-fill.svg": "3f36",
	"./record.svg": "651e",
	"./record2-fill.svg": "8b5d",
	"./record2.svg": "a513",
	"./recycle.svg": "4ac9",
	"./reddit.svg": "e39d",
	"./regex.svg": "9043",
	"./repeat-1.svg": "d328",
	"./repeat.svg": "20df",
	"./reply-all-fill.svg": "3623",
	"./reply-all.svg": "9e83",
	"./reply-fill.svg": "2ac6",
	"./reply.svg": "eedb",
	"./rewind-btn-fill.svg": "88f6",
	"./rewind-btn.svg": "d324",
	"./rewind-circle-fill.svg": "d862",
	"./rewind-circle.svg": "6557",
	"./rewind-fill.svg": "7a15",
	"./rewind.svg": "46f1",
	"./robot.svg": "2810",
	"./rocket-fill.svg": "06e0",
	"./rocket-takeoff-fill.svg": "7224",
	"./rocket-takeoff.svg": "ca97",
	"./rocket.svg": "5d4b",
	"./router-fill.svg": "3984",
	"./router.svg": "a1d0",
	"./rss-fill.svg": "3133",
	"./rss.svg": "6fcc",
	"./rulers.svg": "3223",
	"./safe-fill.svg": "2734",
	"./safe.svg": "bac4",
	"./safe2-fill.svg": "ba87",
	"./safe2.svg": "39ee",
	"./save-fill.svg": "e01e",
	"./save.svg": "5748",
	"./save2-fill.svg": "c9cb",
	"./save2.svg": "37cd",
	"./scissors.svg": "9e3e",
	"./scooter.svg": "d4b6",
	"./screwdriver.svg": "6988",
	"./sd-card-fill.svg": "96c0",
	"./sd-card.svg": "fd7a",
	"./search-heart-fill.svg": "ed26",
	"./search-heart.svg": "24b1",
	"./search.svg": "cecb",
	"./segmented-nav.svg": "5f62",
	"./send-check-fill.svg": "11c1",
	"./send-check.svg": "9e6f",
	"./send-dash-fill.svg": "44b0",
	"./send-dash.svg": "52be",
	"./send-exclamation-fill.svg": "8ad1",
	"./send-exclamation.svg": "365e",
	"./send-fill.svg": "c26d",
	"./send-plus-fill.svg": "828d",
	"./send-plus.svg": "98e3",
	"./send-slash-fill.svg": "34cd",
	"./send-slash.svg": "fb4c",
	"./send-x-fill.svg": "1487",
	"./send-x.svg": "c8da",
	"./send.svg": "fc64",
	"./server.svg": "6838",
	"./share-fill.svg": "8d99",
	"./share.svg": "09bd",
	"./shield-check.svg": "3c8b",
	"./shield-exclamation.svg": "fc5c",
	"./shield-fill-check.svg": "d7aa",
	"./shield-fill-exclamation.svg": "7882",
	"./shield-fill-minus.svg": "773f",
	"./shield-fill-plus.svg": "d772",
	"./shield-fill-x.svg": "bee9",
	"./shield-fill.svg": "049d",
	"./shield-lock-fill.svg": "fc91",
	"./shield-lock.svg": "0c0f",
	"./shield-minus.svg": "bc86",
	"./shield-plus.svg": "1be8",
	"./shield-shaded.svg": "a15e",
	"./shield-slash-fill.svg": "0480",
	"./shield-slash.svg": "959e",
	"./shield-x.svg": "94f1",
	"./shield.svg": "9687",
	"./shift-fill.svg": "9ea9",
	"./shift.svg": "d9d4",
	"./shop-window.svg": "8a28",
	"./shop.svg": "35229",
	"./shuffle.svg": "5234",
	"./sign-dead-end-fill.svg": "6afa",
	"./sign-dead-end.svg": "0060",
	"./sign-do-not-enter-fill.svg": "207c",
	"./sign-do-not-enter.svg": "3431",
	"./sign-intersection-fill.svg": "16c8",
	"./sign-intersection-side-fill.svg": "eb13",
	"./sign-intersection-side.svg": "8fdf",
	"./sign-intersection-t-fill.svg": "7509",
	"./sign-intersection-t.svg": "3043",
	"./sign-intersection-y-fill.svg": "d3d9",
	"./sign-intersection-y.svg": "9e6d",
	"./sign-intersection.svg": "47a0",
	"./sign-merge-left-fill.svg": "bb50",
	"./sign-merge-left.svg": "2c1e",
	"./sign-merge-right-fill.svg": "0572",
	"./sign-merge-right.svg": "db45",
	"./sign-no-left-turn-fill.svg": "8247",
	"./sign-no-left-turn.svg": "aed9f",
	"./sign-no-parking-fill.svg": "e5b3",
	"./sign-no-parking.svg": "f1a9",
	"./sign-no-right-turn-fill.svg": "2bac",
	"./sign-no-right-turn.svg": "ef76",
	"./sign-railroad-fill.svg": "0aae",
	"./sign-railroad.svg": "5c85",
	"./sign-stop-fill.svg": "21c2",
	"./sign-stop-lights-fill.svg": "8a1c",
	"./sign-stop-lights.svg": "d119",
	"./sign-stop.svg": "f274",
	"./sign-turn-left-fill.svg": "cfb7",
	"./sign-turn-left.svg": "8a21",
	"./sign-turn-right-fill.svg": "8a18",
	"./sign-turn-right.svg": "ce40",
	"./sign-turn-slight-left-fill.svg": "9657",
	"./sign-turn-slight-left.svg": "f88a",
	"./sign-turn-slight-right-fill.svg": "b629",
	"./sign-turn-slight-right.svg": "d05bd",
	"./sign-yield-fill.svg": "4650",
	"./sign-yield.svg": "f49b",
	"./signal.svg": "faa6",
	"./signpost-2-fill.svg": "32ae",
	"./signpost-2.svg": "4dcd",
	"./signpost-fill.svg": "5c46",
	"./signpost-split-fill.svg": "d2ad",
	"./signpost-split.svg": "eb69",
	"./signpost.svg": "55b67",
	"./sim-fill.svg": "08f2",
	"./sim.svg": "3402",
	"./sina-weibo.svg": "cf71",
	"./skip-backward-btn-fill.svg": "f612",
	"./skip-backward-btn.svg": "208f",
	"./skip-backward-circle-fill.svg": "8224",
	"./skip-backward-circle.svg": "76c3",
	"./skip-backward-fill.svg": "999b",
	"./skip-backward.svg": "00df",
	"./skip-end-btn-fill.svg": "1b67",
	"./skip-end-btn.svg": "bd45",
	"./skip-end-circle-fill.svg": "0406",
	"./skip-end-circle.svg": "26a1",
	"./skip-end-fill.svg": "a816",
	"./skip-end.svg": "1634",
	"./skip-forward-btn-fill.svg": "bad8",
	"./skip-forward-btn.svg": "ef33",
	"./skip-forward-circle-fill.svg": "9fc5",
	"./skip-forward-circle.svg": "9b73",
	"./skip-forward-fill.svg": "9be8",
	"./skip-forward.svg": "076f",
	"./skip-start-btn-fill.svg": "ef02",
	"./skip-start-btn.svg": "8152",
	"./skip-start-circle-fill.svg": "be61",
	"./skip-start-circle.svg": "8b45",
	"./skip-start-fill.svg": "a871",
	"./skip-start.svg": "f494",
	"./skype.svg": "a26a",
	"./slack.svg": "9888",
	"./slash-circle-fill.svg": "f995",
	"./slash-circle.svg": "2d64",
	"./slash-lg.svg": "ea07",
	"./slash-square-fill.svg": "3d02",
	"./slash-square.svg": "13c6",
	"./slash.svg": "e9de",
	"./sliders.svg": "9e10",
	"./sliders2-vertical.svg": "c00b",
	"./sliders2.svg": "229a",
	"./smartwatch.svg": "5771",
	"./snapchat.svg": "1094",
	"./snow.svg": "1a33",
	"./snow2.svg": "45a5",
	"./snow3.svg": "7f89",
	"./sort-alpha-down-alt.svg": "cf57",
	"./sort-alpha-down.svg": "2834",
	"./sort-alpha-up-alt.svg": "5b6a",
	"./sort-alpha-up.svg": "18503",
	"./sort-down-alt.svg": "9395",
	"./sort-down.svg": "5a2b",
	"./sort-numeric-down-alt.svg": "9a9b",
	"./sort-numeric-down.svg": "b124",
	"./sort-numeric-up-alt.svg": "28c5",
	"./sort-numeric-up.svg": "3887",
	"./sort-up-alt.svg": "5345",
	"./sort-up.svg": "4155",
	"./soundwave.svg": "3e5f",
	"./speaker-fill.svg": "d3ec",
	"./speaker.svg": "5a50",
	"./speedometer.svg": "bdd3",
	"./speedometer2.svg": "4cb9",
	"./spellcheck.svg": "9fca",
	"./spotify.svg": "6426",
	"./square-fill.svg": "b33d",
	"./square-half.svg": "8f9e5",
	"./square.svg": "6f27",
	"./stack-overflow.svg": "bc25",
	"./stack.svg": "da26",
	"./star-fill.svg": "1917",
	"./star-half.svg": "4f53",
	"./star.svg": "482b",
	"./stars.svg": "d051",
	"./steam.svg": "e550",
	"./stickies-fill.svg": "8575",
	"./stickies.svg": "fac1",
	"./sticky-fill.svg": "1978",
	"./sticky.svg": "a334",
	"./stop-btn-fill.svg": "32fe",
	"./stop-btn.svg": "5116",
	"./stop-circle-fill.svg": "476e",
	"./stop-circle.svg": "3df7",
	"./stop-fill.svg": "ac74",
	"./stop.svg": "bce2",
	"./stoplights-fill.svg": "511e",
	"./stoplights.svg": "988e",
	"./stopwatch-fill.svg": "f3cd",
	"./stopwatch.svg": "c20f",
	"./strava.svg": "d3f0",
	"./stripe.svg": "07c4",
	"./subscript.svg": "71fe",
	"./subtract.svg": "5526",
	"./suit-club-fill.svg": "535e",
	"./suit-club.svg": "9ccd",
	"./suit-diamond-fill.svg": "f40e",
	"./suit-diamond.svg": "7e0b",
	"./suit-heart-fill.svg": "8d0b",
	"./suit-heart.svg": "4676",
	"./suit-spade-fill.svg": "10d9",
	"./suit-spade.svg": "e133",
	"./sun-fill.svg": "fdf3",
	"./sun.svg": "9ab2",
	"./sunglasses.svg": "d7bc",
	"./sunrise-fill.svg": "a56c",
	"./sunrise.svg": "3696",
	"./sunset-fill.svg": "f0b9",
	"./sunset.svg": "c7f1",
	"./superscript.svg": "f166",
	"./symmetry-horizontal.svg": "c470",
	"./symmetry-vertical.svg": "9430",
	"./table.svg": "6d14",
	"./tablet-fill.svg": "57b7",
	"./tablet-landscape-fill.svg": "0e5b",
	"./tablet-landscape.svg": "840b",
	"./tablet.svg": "be3b",
	"./tag-fill.svg": "c90f",
	"./tag.svg": "20c8",
	"./tags-fill.svg": "e355",
	"./tags.svg": "5349",
	"./taxi-front-fill.svg": "9f53",
	"./taxi-front.svg": "c514",
	"./telegram.svg": "1c04",
	"./telephone-fill.svg": "5850",
	"./telephone-forward-fill.svg": "0393",
	"./telephone-forward.svg": "49ae",
	"./telephone-inbound-fill.svg": "9845",
	"./telephone-inbound.svg": "0b7c",
	"./telephone-minus-fill.svg": "4b0d",
	"./telephone-minus.svg": "75cc",
	"./telephone-outbound-fill.svg": "73ad",
	"./telephone-outbound.svg": "a14e",
	"./telephone-plus-fill.svg": "436c",
	"./telephone-plus.svg": "eed4",
	"./telephone-x-fill.svg": "4590",
	"./telephone-x.svg": "fe47f",
	"./telephone.svg": "ef25",
	"./tencent-qq.svg": "2ed2",
	"./terminal-dash.svg": "4695",
	"./terminal-fill.svg": "207b",
	"./terminal-plus.svg": "8648",
	"./terminal-split.svg": "c3f9",
	"./terminal-x.svg": "abaa",
	"./terminal.svg": "8f35",
	"./text-center.svg": "6c71",
	"./text-indent-left.svg": "57a99",
	"./text-indent-right.svg": "e7eb",
	"./text-left.svg": "fc7c",
	"./text-paragraph.svg": "bc37",
	"./text-right.svg": "b144",
	"./text-wrap.svg": "3da1",
	"./textarea-resize.svg": "1f39",
	"./textarea-t.svg": "9e77",
	"./textarea.svg": "4bd3",
	"./thermometer-half.svg": "943e",
	"./thermometer-high.svg": "167d",
	"./thermometer-low.svg": "62b8",
	"./thermometer-snow.svg": "658c",
	"./thermometer-sun.svg": "7f3f",
	"./thermometer.svg": "a9ca",
	"./three-dots-vertical.svg": "a271",
	"./three-dots.svg": "355c",
	"./thunderbolt-fill.svg": "3c7d",
	"./thunderbolt.svg": "ce3f",
	"./ticket-detailed-fill.svg": "89b6",
	"./ticket-detailed.svg": "41cf",
	"./ticket-fill.svg": "ddac",
	"./ticket-perforated-fill.svg": "f56d",
	"./ticket-perforated.svg": "a5be",
	"./ticket.svg": "1122",
	"./tiktok.svg": "6ad7",
	"./toggle-off.svg": "4792",
	"./toggle-on.svg": "6156",
	"./toggle2-off.svg": "9886",
	"./toggle2-on.svg": "b3b9",
	"./toggles.svg": "38cb",
	"./toggles2.svg": "20c3",
	"./tools.svg": "e6da",
	"./tornado.svg": "2298",
	"./train-freight-front-fill.svg": "a69b",
	"./train-freight-front.svg": "03aa",
	"./train-front-fill.svg": "aa82",
	"./train-front.svg": "fabf",
	"./train-lightrail-front-fill.svg": "b95d",
	"./train-lightrail-front.svg": "b5ca",
	"./translate.svg": "3ff9",
	"./trash-fill.svg": "0ec4",
	"./trash.svg": "14d1",
	"./trash2-fill.svg": "6165",
	"./trash2.svg": "9c1e",
	"./trash3-fill.svg": "6a16",
	"./trash3.svg": "eded",
	"./tree-fill.svg": "7b76",
	"./tree.svg": "20d9",
	"./trello.svg": "0095",
	"./triangle-fill.svg": "3ebc",
	"./triangle-half.svg": "a8ef",
	"./triangle.svg": "b84a",
	"./trophy-fill.svg": "0105",
	"./trophy.svg": "9a24",
	"./tropical-storm.svg": "8625",
	"./truck-flatbed.svg": "bc12",
	"./truck-front-fill.svg": "3c1d",
	"./truck-front.svg": "d684",
	"./truck.svg": "8b26",
	"./tsunami.svg": "223f",
	"./tv-fill.svg": "5136",
	"./tv.svg": "132b",
	"./twitch.svg": "8b34",
	"./twitter.svg": "0138",
	"./type-bold.svg": "af89",
	"./type-h1.svg": "99b1",
	"./type-h2.svg": "4008",
	"./type-h3.svg": "0fe0",
	"./type-italic.svg": "ede6",
	"./type-strikethrough.svg": "1e764",
	"./type-underline.svg": "47a3",
	"./type.svg": "47b0",
	"./ubuntu.svg": "e0ea",
	"./ui-checks-grid.svg": "12f5",
	"./ui-checks.svg": "8e63",
	"./ui-radios-grid.svg": "690b",
	"./ui-radios.svg": "7caf",
	"./umbrella-fill.svg": "6f7a",
	"./umbrella.svg": "5f2c",
	"./unindent.svg": "5691",
	"./union.svg": "0518",
	"./unity.svg": "bb30",
	"./universal-access-circle.svg": "c053",
	"./universal-access.svg": "5a1a",
	"./unlock-fill.svg": "70c3",
	"./unlock.svg": "4314",
	"./upc-scan.svg": "4dee",
	"./upc.svg": "4dc3",
	"./upload.svg": "40ca",
	"./usb-c-fill.svg": "d7e9",
	"./usb-c.svg": "bfd5",
	"./usb-drive-fill.svg": "d1f1",
	"./usb-drive.svg": "f70a",
	"./usb-fill.svg": "ee8c",
	"./usb-micro-fill.svg": "7ec5",
	"./usb-micro.svg": "a3d7",
	"./usb-mini-fill.svg": "52fc",
	"./usb-mini.svg": "59bd",
	"./usb-plug-fill.svg": "41af",
	"./usb-plug.svg": "0f85",
	"./usb-symbol.svg": "2ffb",
	"./usb.svg": "3cdb",
	"./valentine.svg": "51ad",
	"./valentine2.svg": "7d70",
	"./vector-pen.svg": "2857",
	"./view-list.svg": "e510",
	"./view-stacked.svg": "cb3b",
	"./vimeo.svg": "ffc1",
	"./vinyl-fill.svg": "1bb0",
	"./vinyl.svg": "6956",
	"./virus.svg": "fb88",
	"./virus2.svg": "17f9",
	"./voicemail.svg": "7408",
	"./volume-down-fill.svg": "2ca3",
	"./volume-down.svg": "8ae1",
	"./volume-mute-fill.svg": "99ef",
	"./volume-mute.svg": "69ac",
	"./volume-off-fill.svg": "ba04",
	"./volume-off.svg": "ab6d",
	"./volume-up-fill.svg": "d807",
	"./volume-up.svg": "10f5",
	"./vr.svg": "5494",
	"./wallet-fill.svg": "648d",
	"./wallet.svg": "132e",
	"./wallet2.svg": "5c17",
	"./watch.svg": "9025",
	"./water.svg": "8aa50",
	"./webcam-fill.svg": "a56b",
	"./webcam.svg": "f89a",
	"./wechat.svg": "700e",
	"./whatsapp.svg": "dd4c",
	"./wifi-1.svg": "3bc9",
	"./wifi-2.svg": "9fd9",
	"./wifi-off.svg": "1692",
	"./wifi.svg": "6c7e",
	"./wikipedia.svg": "9010",
	"./wind.svg": "ac20",
	"./window-dash.svg": "8551",
	"./window-desktop.svg": "bb0f",
	"./window-dock.svg": "1a02",
	"./window-fullscreen.svg": "2531",
	"./window-plus.svg": "3464",
	"./window-sidebar.svg": "d0f5",
	"./window-split.svg": "57e5",
	"./window-stack.svg": "a5ff",
	"./window-x.svg": "481f",
	"./window.svg": "bf15",
	"./windows.svg": "2923",
	"./wordpress.svg": "a5e8",
	"./wrench-adjustable-circle-fill.svg": "c730",
	"./wrench-adjustable-circle.svg": "104c",
	"./wrench-adjustable.svg": "7e0c",
	"./wrench.svg": "b277",
	"./x-circle-fill.svg": "5d25",
	"./x-circle.svg": "9fe4",
	"./x-diamond-fill.svg": "8d34",
	"./x-diamond.svg": "5b4b",
	"./x-lg.svg": "07dd",
	"./x-octagon-fill.svg": "26ee3",
	"./x-octagon.svg": "1684",
	"./x-square-fill.svg": "fb0a",
	"./x-square.svg": "6830",
	"./x.svg": "d664",
	"./xbox.svg": "be0d",
	"./yelp.svg": "87a3",
	"./yin-yang.svg": "0c51",
	"./youtube.svg": "427d",
	"./zoom-in.svg": "24b6",
	"./zoom-out.svg": "fa14"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "77f2";